(() => {
  const panel = document.getElementById('tb-preferences-panel');
  if (!panel) return;
  const fields = panel.querySelector('#tb-preferences-fields');
  const status = panel.querySelector('[data-preferences-status]');
  const categories = ['preferences', 'analytics', 'marketing'];
  const hash = '#shopifyReshowConsentBanner';
  let opener;
  let servicePromise;

  function service() {
    if (typeof window.Shopify?.customerPrivacy?.currentVisitorConsent === 'function' &&
        typeof window.Shopify?.customerPrivacy?.setTrackingConsent === 'function') {
      return Promise.resolve(window.Shopify.customerPrivacy);
    }
    if (!servicePromise) {
      servicePromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = panel.dataset.preferencesService;
        script.onload = () => {
          const api = window.Shopify?.customerPrivacy;
          if (typeof api?.currentVisitorConsent === 'function' && typeof api?.setTrackingConsent === 'function') resolve(api);
          else reject(new Error('Consent service unavailable'));
        };
        script.onerror = () => reject(new Error('Consent service could not load'));
        document.head.appendChild(script);
      }).catch((error) => {
        servicePromise = undefined;
        throw error;
      });
    }
    return servicePromise;
  }

  function showSavedChoices(api) {
    const choices = api.currentVisitorConsent();
    categories.forEach((key) => {
      panel.querySelector('[name="' + key + '"]').checked = choices[key] === 'yes';
    });
  }

  async function openPreferences(target) {
    opener = target || document.activeElement;
    fields.disabled = true;
    status.textContent = panel.dataset.loading;
    if (!panel.open) panel.showModal();
    try {
      const api = await service();
      showSavedChoices(api);
      fields.disabled = false;
      status.textContent = '';
    } catch (error) {
      status.textContent = panel.dataset.loadError;
      console.warn('TrainBot preferences service unavailable.', error);
    }
  }

  async function savePreferences(value) {
    fields.disabled = true;
    status.textContent = panel.dataset.saving;
    try {
      const api = await service();
      const choices = Object.fromEntries(categories.map((key) => [key,
        typeof value === 'boolean' ? value : panel.querySelector('[name="' + key + '"]').checked
      ]));
      // Preserve Shopify's separate data-sale choice and Global Privacy Control.
      api.setTrackingConsent(choices, (error) => {
        const saved = api.currentVisitorConsent();
        const matches = categories.every((key) => saved[key] === (choices[key] ? 'yes' : 'no'));
        status.textContent = !error?.error && matches ? panel.dataset.saved : panel.dataset.saveError;
        showSavedChoices(api);
        fields.disabled = false;
      });
    } catch (error) {
      status.textContent = panel.dataset.saveError;
      fields.disabled = false;
      console.warn('TrainBot preferences could not be saved.', error);
    }
  }

  panel.querySelector('[data-preferences-close]').addEventListener('click', () => panel.close());
  panel.addEventListener('close', () => opener?.focus?.());
  panel.querySelector('[data-preferences-save]').addEventListener('click', () => savePreferences());
  panel.querySelector('[data-preferences-decline]').addEventListener('click', () => savePreferences(false));
  panel.querySelector('[data-preferences-accept]').addEventListener('click', () => savePreferences(true));
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[href]');
    if (!link || !link.getAttribute('href').endsWith(hash)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    openPreferences(link);
  }, true);
  window.addEventListener('hashchange', () => {
    if (window.location.hash === hash) openPreferences();
  });
  if (window.location.hash === hash) openPreferences();
})();
